import { ChangeDetectionStrategy, Component, Input, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { WorksheetService } from '../../../services/worksheet.service';
import { WorksheetDto } from '../../../models/worksheet-dto.interface';

@Component({
  selector: 'app-job-worksheet',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
  templateUrl: './job-worksheet.component.html',
  styleUrl: './job-worksheet.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JobWorksheetComponent implements OnInit {
  @Input() jobId!: number;

  protected readonly worksheets = signal<WorksheetDto[]>([]);
  protected readonly isLoading = signal(false);

  private readonly worksheetService = inject(WorksheetService);

  ngOnInit(): void {
    this.isLoading.set(true);
    this.worksheetService.getJobWorksheets(this.jobId).subscribe({
      next: (data) => {
        this.worksheets.set(data);
        this.isLoading.set(false);
      },
      error: () => this.isLoading.set(false)
    });
  }

  protected openPrintTab(ws: WorksheetDto): void {
    window.open(`/jobs/${this.jobId}/worksheets/${ws.testGroupId}`, '_blank');
  }
}
